<template>
    <div>
        <H1>There is no such page on this site</H1>
    <div>
        {{ $route.params.pathMatch}}
    </div>
    </div>


</template>

<script>
    export default {
                metaInfo() {
                    return {}
                }

    }
</script>

<style lang="scss" scoped>

</style>